<template>
  <div class="pal">
    <label>
      <span v-if="locked" class="af-icons af-icons-lock"></span>
      {{ lang.get('tabs.form.type.label') }}
    </label>
    <template v-if="locked">
      <div class="form-control configuring">
        {{ lang.get('tabs.types.' + tab.type) }}
      </div>
    </template>
    <template v-else>
      <select
        class="form-control"
        @change="e => handleInput('type', e.target.value)"
      >
        <option></option>
        <option
          v-for="type in tabTypes"
          :key="type"
          :value="type"
          :selected="tab.type === type"
        >
          {{ lang.get('tabs.types.' + type) }}
        </option>
      </select>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  mixins: [handleInputMixin],
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['tabTypes']),
    locked() {
      return this.tab.createdAt !== null;
    }
  }
};
</script>
